import React, { useState } from 'react'

// components
import SideViewModal from '../../../../../components/modals/SideViewModal/SideViewModal.component'

// collections
import FinishTimeTickets from './FinishTimeTickets.form'
// queries
import { apolloClient } from '../../../../..'
import { useMutation } from '@apollo/client'
import { FINISH_TIME_TICKETS_MUTATION } from '../../../../../graphql/crewMemberAssignment/crewMemberAssignment.mutations'
import { GET_JOB_DAY_BY_ID_WITH_ASSIGNMENTS_FOR_FINISH_TIME_TICKETS_FORM } from '../../../../../graphql/jobDay/jobDay.queries'

// utils
import { createAssignmentsFromData, createSubmitData } from './FinishTimeTickets.form.controller.utils'
import { validate } from '../../../../../shared/utility'

const validationSchema = {
    assignments: {
        type: 'list',
        fields: {
            id: {
                type: "input",
                validation: {
                    required: true
                }
            },
            startTime: {
                type: 'time',
                validation: {
                    required: true,
                    isTime: true
                }
            },
            endTime: {
                type: 'time',
                validation: {
                    required: true,
                    isTime: true
                }
            }
        }
    }
}

export default function FinishTimeTicketsFormController({ id, visible, closeForm }) {
    const [isFetchingObject, setIsFetchingObject] = useState(true)
    const [assignments, setAssignments] = useState(null)
    const [jobDay, setJobDay] = useState(null)
    const [errors, setErrors] = useState({ assignments: [] })
    const [finishTimeTickets] = useMutation(FINISH_TIME_TICKETS_MUTATION)

    const handleSubmit = (formData) => {
        const { isValid, errors } = validate(formData, validationSchema)

        if (isValid) {
            const submitData = createSubmitData(formData);
            
            // Convert string IDs to integers
            submitData.assignments = submitData.assignments.map(assignment => ({
                ...assignment,
                id: parseInt(assignment.id)
            }));

            finishTimeTickets({ 
                variables: { ...submitData },
                refetchQueries: []
            })
            .catch(e => { console.error(e) })
            .then(result => {
                if (result) {
                    setErrors({ assignments: [] })
                    closeForm()
                    setIsFetchingObject(true)
                }
            })
        } else {
            setErrors(errors)
        }
    }

    if (visible && isFetchingObject) {
        apolloClient.query({ 
            query: GET_JOB_DAY_BY_ID_WITH_ASSIGNMENTS_FOR_FINISH_TIME_TICKETS_FORM, 
            variables: { id }
        })
        .catch(e => {})
        .then(result => {
            if (result) {
                setAssignments(createAssignmentsFromData(result.data.jobDay.crewMemberAssignments))
                setJobDay(result.data.jobDay)
                setIsFetchingObject(false)
            }
        })

        return null
    }

    else if (visible && !isFetchingObject && assignments) {
        const editVariants = [
            {
                name: 'Edit Time Tickets',
                component: <FinishTimeTickets />,
                stages: 1
            }
        ]

        return (
            <SideViewModal
                show={visible}
                submitText={'Save Changes'}
                onClose={() => {
                    setErrors({ assignments: [] })
                    closeForm()
                }}
                onSubmit={handleSubmit}
                title='Edit Time Tickets'
                variants={editVariants}
                prefillData={{ assignments, jobDay }}
                errors={errors}
            />
        )
    }

    return null
}
